<template>
  <div>
    <div>
      <div class="box box-primary">
        <div class="box-header">
          <h3 class="box-title">{{ $t("mail_form.title_add_new") }}</h3>
        </div>
        <form>
          <div class="box-body">
            <div>
              <p>{{ $t("mail_form.title_intro") }}</p>
            </div>
            <div>
              <!-- classify -->
              <div class="contain_info">
                <div>{{ $t("mail_form.classify") }}</div>
                <div style="width:75%">
                  <select
                    @change="handleOnClassify(keyClassify)"
                    class="form-control"
                    v-model="keyClassify"
                    :disabled="form.id != 0"
                  >
                    <option
                      v-for="item in classify"
                      v-bind:value="item.id"
                      :key="item.id"
                      >{{ $t(item.text) }}</option
                    >
                  </select>
                </div>
              </div>
              <!-- choose field -->
              <div class="contain_info">
                <div>{{ $t("mail_form.choose_field") }}</div>
                <div style="width:75%">
                  <select
                    @change="handleOnPickField(keyPField)"
                    class="form-control"
                    v-model="keyPField"
                  >
                    <option
                      v-for="item in pickfields"
                      v-bind:value="item"
                      :key="item.id"
                      >{{ item.text }}</option
                    >
                  </select>
                </div>
              </div>
              <!-- copy field -->
              <div style="display: flex; justify-content: space-between">
                <div>{{ $t("mail_form.copy_field") }}</div>
                <div style="width: 75%" class="contain_info">
                  <span class="text-center">{{ form.copyfield }}</span>
                  <input
                    type="hidden"
                    id="inputcopy"
                    v-model="form.copyfield"
                  />
                  <!-- <span
                    class="btn btn-info text-white ml-auto"
                    @click.prevent="copyFunction"
                    ><i class="fa fa-copy"></i
                  ></span> -->
                </div>
              </div>
              <div style="margin-bottom: 5%">
                <h4>{{ $t("mail_form.email_form_info") }}</h4>
              </div>
              <!-- active -->
              <!-- <div class="contain_info">
                <div>{{ $t("mail_form.active") }}</div>
                <div style="width: 75%">
                  <input type="checkbox" v-model="form.active" id="checkbox" />
                </div>
              </div> -->
              <!-- form name -->
              <div class="contain_info">
                <div>{{ $t("mail_form.form_name") }}</div>
                <input type="text" v-model="form.formname" style="width: 75%" />
              </div>
              <div class="contain_info">
                <div>{{ $t("mail_form.description") }}</div>
                <input
                  type="text"
                  v-model="form.description"
                  style="width: 75%"
                />
              </div>
              <div class="contain_info">
                <div>{{ $t("mail_form.subject") }}</div>
                <input type="text" v-model="form.subject" style="width: 75%" />
              </div>
              <!-- content  -->
              <div>
                <label for="subject">{{ $t("mail_form.content") }}</label>
                <div>
                  <trumbowyg
                    v-model="form.content"
                    :config="config"
                    name="content"
                  ></trumbowyg>
                </div>
              </div>

              <!------------------------>
            </div>
          </div>
        </form>
        <div class="box-footer">
          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="onCancel"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>
          <button
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="onSubmit"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button>
        </div>
      </div>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import loading from "vue-loading-overlay";
// Import this component
import Trumbowyg from "vue-trumbowyg";
import { mapActions, mapGetters } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
// Import editor css
import "trumbowyg/dist/ui/trumbowyg.css";
// import utils from '@/lib/utils'

export default {
  name: "EmailFormAdd",
  data() {
    return {
      config: {
        // Get options from
        // https://alex-d.github.io/Trumbowyg/documentation
      },
      isLoading: false,
      keyPField: "",
      keyClassify: "",
      form: {
        id: null,
        classify: null,
        pickfield: null,
        active: true,
        formname: null,
        description: null,
        subject: null,
        content: null,
        copyfield: null
      },
      pickfields: [],
      fields: [],
      classify: []
    };
  },
  computed: {
    ...mapGetters([
      "GET_TEMPLATE_EMAIL_OB_DATA",
      "GET_SNACK_BAR",
      "GET_TEMPLATE_DETAIL_DATA"
    ])
  },
  watch: {
    GET_TEMPLATE_DETAIL_DATA: function() {
      // let id = this.$route.params.id;
      // this.classify = [];
      // this.GET_TEMPLATE_DETAIL_DATA.forEach(item => {
      //   if (item.id == id) {
      //     // this.keyClassify = item.email_object;
      //     this.form.active = item.active;
      //     this.form.formname = item.name;
      //     this.form.description = item.description;
      //     this.form.subject = item.subject;
      //     this.form.content = item.content;
      //     this.keyClassify = item.email_object;
      //     this.handleOnClassify(this.keyClassify);
      //     let data = {
      //       id: item.email_object, //name0
      //       text: item.classify //id
      //     };
      //     this.classify.push(data);
      //   }
      // });
      this.classify = [];
      let data = this.GET_TEMPLATE_DETAIL_DATA
      this.form.active = data.active;
      this.form.formname = data.name;
      this.form.description = data.description;
      this.form.subject = data.subject;
      this.form.content = data.content;
      this.keyClassify = data.email_object;
      this.handleOnClassify(this.keyClassify);
      let item = {
        id: data.email_object, //name0
        text: data.classify //id
      };
      this.classify.push(item);
    },
    GET_TEMPLATE_EMAIL_OB_DATA: function() {
      this.classify = [];
      this.fields = [];
      this.GET_TEMPLATE_EMAIL_OB_DATA.forEach(item => {
        let pickfield = item.fields;
        let data = {
          id: item.id,
          text: item.name
        };

        this.classify.push(data);
        this.fields.push(pickfield);
      });
    }
  },
  methods: {
    ...mapActions([
      "GET_TEMPLATE_EMAIL_OBJECT",
      "ADD_TEMPLATE_EMAIL",
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "UPDATE_TEMPLATE_EMAIL",
      "GET_TEMPLATE_DETAIL",
      "ERROR_TOAST"
    ]),
    onCancel() {
      // this.$router.push({
      //   name: "ManagementEmailFormList"
      // });
      window.history.back()
    },
    copyFunction(value) {
      let copyText = document.getElementById("inputcopy");
      copyText.setAttribute("type", "text");
      copyText.select();
      document.execCommand("copy");
      copyText.setAttribute("type", "hidden");
      alert("Copied the text: " + copyText.value);
    },
    handleOnPickField(item) {
      let text = item.text;
      this.form.copyfield = `{{ ${text} }}`;
    },
    handleOnClassify(id) {
      this.pickfields = [];
      this.fields[id - 1].forEach((el, idx) => {
        let data = {
          id: idx,
          text: el.api
        };
        this.pickfields.push(data);
      });
    },
    onSubmit() {
      let id = parseInt(this.$route.params.id);
      let data = {
        id: id,
        classify: this.keyClassify,
        pickfield: this.keyPField,
        active: this.form.active,
        name: this.form.formname,
        description: this.form.description,
        subject: this.form.subject,
        content: this.form.content
      };
      this.isLoading = true;
      if (id == 0) {
        this.ADD_TEMPLATE_EMAIL(data)
          .then(
            function() {
              this.SUCCESS_TOAST();
              this.$router.push({
                name: "ManagementEmailFormList"
              });
              this.isLoading = false;
            }.bind(this)
          )
          .catch(
            function() {
              this.ERROR_TOAST();
              this.isLoading = false;
            }.bind(this)
          );
      } else {
        this.UPDATE_TEMPLATE_EMAIL(data)
          .then(
            function() {
              this.SUCCESS_TOAST();
              this.$router.push({
                name: "ManagementEmailFormList"
              });
              this.isLoading = false;
            }.bind(this)
          )
          .catch(
            function() {
              this.ERROR_TOAST();
              this.isLoading = false;
            }.bind(this)
          );
      }
    }
  },
  mounted() {
    let id = this.$route.params.id;
    this.form.id = id;
    if (parseInt(id) !== 0) {
      this.GET_TEMPLATE_DETAIL({id: id});
    }
    this.GET_TEMPLATE_EMAIL_OBJECT();
  },
  components: {
    loading: loading,
    Trumbowyg,
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<style>
.contain_info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4%;
}
</style>



// WEBPACK FOOTER //
// src/views/Mailbox/EmailFormAdd.vue